import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import { eventBus } from '@spon/plugins';
import Tempus from 'tempus';

gsap.registerPlugin(ScrollTrigger);

function Scroll() {
	// Default settings that can't be changed
	const defaultSettings = {
		syncTouch: false,
		smoothWheel: true,
		prevent: ({ el }) => {
			if (!el) return false;
			if (el.closest('.yii-debug-toolbar')) return true;
		},
	};

	// Settings that can be adjusted via UI
	let currentSettings = {
		...defaultSettings,
	};

	// Create new instance with current settings
	const lenis = new Lenis(currentSettings);
	window.lenis = lenis;

	// Update ScrollTrigger on Lenis scroll
	window.lenis.on('scroll', scroll => {
		eventBus.emit('scroll:update', scroll);
		ScrollTrigger.update();
	});

	Tempus.add(window.lenis.raf, {
		priority: -1,
		fps: 60,
	});

	// Remove GSAP's internal RAF
	gsap.ticker.remove(gsap.updateRoot);
	Tempus.add(
		time => {
			gsap.updateRoot(time / 1000);
		},
		{
			fps: 60,
		}
	);

	// gsap.ticker.add(time => {
	// 	lenis.raf(time * 1000);
	// });

	// Disable lag smoothing in GSAP to prevent any delay in scroll animations
	gsap.ticker.lagSmoothing(0);

	// Event handlers
	eventBus.on('scroll:top', () => {
		setTimeout(() => {
			window.lenis.scrollTo(0, {
				force: true,
				immediate: true,
				lock: true,
			});
		}, 100);
	});

	eventBus.on('scroll:pause', (toTop = false) => {
		if (toTop) {
			window.lenis.scrollTo(0, {
				force: true,
				immediate: true,
				lock: false,
			});
		}
		window.lenis.stop();
	});

	eventBus.on('scroll:play', () => {
		window.lenis.start();
	});

	eventBus.on('scroll:toElement', el => {
		window.lenis.scrollTo(el.offsetTop - 100);
	});

	eventBus.on('scroll:to', ({ scrollY, immediate = false, force = false }) => {
		window.lenis.scrollTo(scrollY, { immediate: immediate, force: force });
	});
}

export default Scroll;
